import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/pop/devices.js';

export default function Web() {
  return (
    <PageWrap size="l">
      <Grid columns={12} alignItems="center">
        <GridItem columnSpan={12} columnSpanM={6}>
          <MediaMultipleImages
            fallbackImageAlt={assets.all.alt}
            fallbackImageMaxWidth={assets.all.maxWidth}
            fallbackImageSrc={assets.all.src}
          >
            <Shape
              color="brightOrange"
              height={250}
              left="10%"
              top="10%"
              type="losange"
              width={450}
            />
            <Pattern
              type="shortRectangle"
              top="35%"
              left="13%"
              color="orangeLight"
            />

            <ParallaxWrapper speed={1.6}>
              <Image
                {...assets.iPad}
                borderRadius="m"
                left="20%"
                position="absolute"
                top="5%"
              />
              <Image
                {...assets.iPhone}
                borderRadius="m"
                left="10%"
                position="absolute"
                top="30%"
              />
              <Image
                {...assets.pixel}
                borderRadius="m"
                right="20%"
                position="absolute"
                top="30%"
              />
              <Image
                {...assets.stars}
                borderRadius="m"
                right="24%"
                position="absolute"
                top="6%"
              />
            </ParallaxWrapper>
            <ParallaxWrapper speed={0.8}>
              <Image
                {...assets.appleTV}
                borderRadius="m"
                position="absolute"
                left="47%"
                top="55%"
              />
            </ParallaxWrapper>
          </MediaMultipleImages>
        </GridItem>
        <GridItem columnSpan={12} columnSpanM={6}>
          <Spacing size="l" sizeM="0" type="margin" position="bottom">
            <HeadingBlock
              size="s"
              spacing="m"
              justifyM="center"
              title="View your prototypes on any device"
              copy="POP supports on iPhone, iPad, Apple Watch, Apple TV and Android."
            />
          </Spacing>
        </GridItem>
      </Grid>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pop/Devices.js